import { render, staticRenderFns } from "./ManageAdminDetail.vue?vue&type=template&id=33d7dd8e"
import script from "./ManageAdminDetail.vue?vue&type=script&lang=js"
export * from "./ManageAdminDetail.vue?vue&type=script&lang=js"
import style0 from "./ManageAdminDetail.vue?vue&type=style&index=0&id=33d7dd8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports